import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import TopBar from "../components/layout/TopBar";
import { partnersList, partners } from "../data/demoData";

const shell: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

const sectionCard: React.CSSProperties = {
  background: "var(--surface)",
  borderRadius: "28px",
  padding: "28px",
  border: "1px solid var(--line)",
  boxShadow: "0 18px 50px rgba(20, 20, 20, 0.06)",
};

const heroGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1.2fr) minmax(320px, 0.8fr)",
  gap: "20px",
  alignItems: "stretch",
};

const heroLeft: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "18px",
};

const badge: React.CSSProperties = {
  display: "inline-flex",
  width: "fit-content",
  padding: "8px 14px",
  borderRadius: "999px",
  background: "var(--surface-2)",
  border: "1px solid var(--line-2)",
  color: "var(--accent)",
  fontSize: "12px",
  fontWeight: 800,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

const title: React.CSSProperties = {
  margin: 0,
  fontSize: "42px",
  lineHeight: 1.05,
  fontWeight: 800,
  letterSpacing: "-0.04em",
  color: "var(--text)",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const subtitle: React.CSSProperties = {
  margin: 0,
  maxWidth: "680px",
  fontSize: "15px",
  lineHeight: 1.7,
  color: "var(--text-muted)",
};

const quickInfoWrap: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: "12px",
};

const quickInfoCard: React.CSSProperties = {
  background: "var(--surface-2)",
  border: "1px solid var(--line)",
  borderRadius: "20px",
  padding: "18px",
};

const quickInfoLabel: React.CSSProperties = {
  margin: "0 0 10px 0",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "var(--text-dim)",
};

const quickInfoValue: React.CSSProperties = {
  margin: 0,
  fontSize: "30px",
  fontWeight: 800,
  color: "var(--text)",
};

const quickInfoHint: React.CSSProperties = {
  margin: "6px 0 0 0",
  fontSize: "13px",
  color: "var(--text-muted)",
};

const rightAccentCard: React.CSSProperties = {
  height: "100%",
  minHeight: "220px",
  background: "linear-gradient(180deg, #191921 0%, #131318 100%)",
  border: "1px solid var(--line)",
  borderRadius: "24px",
  padding: "22px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const rightAccentTop: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "12px",
};

const rightAccentDot: React.CSSProperties = {
  width: "14px",
  height: "14px",
  borderRadius: "999px",
  background: "var(--accent)",
  boxShadow: "0 0 0 8px rgba(201, 243, 29, 0.14)",
};

const rightAccentTitle: React.CSSProperties = {
  margin: 0,
  fontSize: "15px",
  fontWeight: 800,
  color: "var(--text)",
};

const rightAccentText: React.CSSProperties = {
  margin: "8px 0 0 0",
  fontSize: "14px",
  lineHeight: 1.6,
  color: "var(--text-muted)",
};

const rightAccentBottom: React.CSSProperties = {
  display: "grid",
  gap: "10px",
};

const lineItem: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  paddingBottom: "10px",
  borderBottom: "1px solid var(--line)",
  fontSize: "14px",
};

const controlsGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "minmax(320px, 420px) minmax(0, 1fr)",
  gap: "20px",
};

const panelCard: React.CSSProperties = {
  background: "var(--surface-2)",
  border: "1px solid var(--line)",
  borderRadius: "24px",
  padding: "22px",
};

const sectionLabel: React.CSSProperties = {
  margin: "0 0 16px 0",
  fontSize: "13px",
  fontWeight: 700,
  color: "var(--text-dim)",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const infoBox: React.CSSProperties = {
  background: "var(--surface)",
  border: "1px solid var(--line)",
  borderRadius: "18px",
  padding: "18px",
};

const infoBoxTitle: React.CSSProperties = {
  margin: "0 0 8px 0",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "var(--text-dim)",
};

const infoBoxValue: React.CSSProperties = {
  margin: 0,
  fontSize: "20px",
  fontWeight: 800,
  color: "var(--text)",
};

const searchBox: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "14px",
};

const input: React.CSSProperties = {
  width: "100%",
  height: "54px",
  borderRadius: "16px",
  border: "1px solid var(--line)",
  background: "var(--bg-soft)",
  padding: "0 16px",
  fontSize: "15px",
  color: "var(--text)",
  outline: "none",
};

const helperText: React.CSSProperties = {
  margin: 0,
  fontSize: "13px",
  lineHeight: 1.6,
  color: "var(--text-dim)",
};

const partnersListStyle: React.CSSProperties = {
  display: "grid",
  gap: "12px",
  marginTop: "6px",
  maxHeight: "360px",
  overflowY: "auto",
  paddingRight: "4px",
};

const partnerRow: React.CSSProperties = {
  background: "var(--surface)",
  border: "1px solid var(--line)",
  borderRadius: "18px",
  padding: "16px 18px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  cursor: "pointer",
};

const selectedPartnerRow: React.CSSProperties = {
  ...partnerRow,
  border: "1px solid var(--accent)",
  boxShadow: "var(--glow-soft)",
  background: "rgba(201, 243, 29, 0.03)",
};

const partnerName: React.CSSProperties = {
  margin: 0,
  fontSize: "16px",
  fontWeight: 700,
  color: "var(--text)",
};

const partnerMeta: React.CSSProperties = {
  margin: "4px 0 0 0",
  fontSize: "13px",
  color: "var(--text-muted)",
};

const selectBadge: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "92px",
  height: "40px",
  padding: "0 14px",
  borderRadius: "999px",
  background: "var(--accent)",
  color: "var(--on-accent)",
  fontWeight: 700,
  fontSize: "14px",
  boxShadow: "var(--glow)",
};

const emptyState: React.CSSProperties = {
  background: "var(--surface)",
  border: "1px dashed var(--line-2)",
  borderRadius: "18px",
  padding: "24px",
  color: "var(--text-muted)",
  fontSize: "14px",
};

const machinesSection: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

const selectedPartnerCard: React.CSSProperties = {
  background: "rgba(201, 243, 29, 0.05)",
  border: "1px solid rgba(201, 243, 29, 0.28)",
  borderRadius: "22px",
  padding: "20px",
};

const selectedPartnerTitle: React.CSSProperties = {
  margin: "0 0 6px 0",
  fontSize: "24px",
  fontWeight: 800,
  color: "var(--text)",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const selectedPartnerSub: React.CSSProperties = {
  margin: 0,
  fontSize: "14px",
  color: "var(--text-muted)",
  lineHeight: 1.6,
};

const machinesGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: "16px",
};

const machineCard: React.CSSProperties = {
  background: "var(--surface)",
  border: "1px solid var(--line)",
  borderRadius: "22px",
  padding: "20px",
  boxShadow: "0 10px 25px rgba(20, 20, 20, 0.04)",
};

const machineLabel: React.CSSProperties = {
  margin: "0 0 8px 0",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "var(--text-dim)",
};

const machineTitle: React.CSSProperties = {
  margin: "0 0 10px 0",
  fontSize: "20px",
  fontWeight: 800,
  color: "var(--text)",
  fontFamily: "Montserrat",
  textTransform: "uppercase",
};

const machineText: React.CSSProperties = {
  margin: "0 0 6px 0",
  fontSize: "14px",
  color: "var(--text-muted)",
  lineHeight: 1.5,
};

const machineFooter: React.CSSProperties = {
  marginTop: "16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
};

const machineStatus: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  padding: "8px 12px",
  borderRadius: "999px",
  background: "var(--surface-2)",
  border: "1px solid var(--line)",
  fontSize: "13px",
  fontWeight: 700,
  color: "var(--text)",
};

const openButton: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "42px",
  padding: "0 16px",
  borderRadius: "999px",
  border: "none",
  background: "var(--accent)",
  color: "var(--on-accent)",
  fontWeight: 700,
  textDecoration: "none",
  whiteSpace: "nowrap",
  boxShadow: "var(--glow)",
};

const bottomNote: React.CSSProperties = {
  paddingTop: "8px",
  color: "var(--text-dim)",
  fontSize: "12px",
  lineHeight: 1.5,
};

type PartnerItem = {
  id: number;
  name: string;
  machinesCount: number;
};

const PartnersPage = () => {
  const [search, setSearch] = useState("");
  const [selectedPartnerId, setSelectedPartnerId] = useState<number | null>(null);

  const partnerItems = useMemo<PartnerItem[]>(() => {
    return partnersList.map((partner) => {
      const machines = partners.filter((machine) => machine.partnerId === partner.id);

      return {
        id: partner.id,
        name: partner.name,
        machinesCount: machines.length,
      };
    });
  }, []);

  const filteredPartners = useMemo(() => {
    const normalized = search.trim().toLowerCase();

    if (!normalized) {
      return partnerItems;
    }

    return partnerItems.filter((partner) =>
      partner.name.toLowerCase().includes(normalized)
    );
  }, [partnerItems, search]);

  const selectedPartner = useMemo(() => {
    if (selectedPartnerId === null) {
      return null;
    }

    return partnerItems.find((partner) => partner.id === selectedPartnerId) ?? null;
  }, [partnerItems, selectedPartnerId]);

  const selectedPartnerMachines = useMemo(() => {
    if (selectedPartnerId === null) {
      return [];
    }

    return partners.filter((machine) => machine.partnerId === selectedPartnerId);
  }, [selectedPartnerId]);

  return (
    <div className="page-shell">
      <div className="page-container">
        <TopBar
          title="Управление автоматами"
          subtitle="Выбери партнёра, посмотри количество его аппаратов и перейди к нужному автомату."
        />

        <div style={shell}>
          <div style={sectionCard}>
            <div style={heroGrid}>
              <div style={heroLeft}>
                <div>
                  <div style={badge}>БАТЯ ЗНАЕТ • Партнёры</div>
                  <h1 style={title}>Контроль партнёров и аппаратов</h1>
                  <p style={subtitle}>
                    Сначала выбери партнёра из списка. После выбора ниже отобразятся
                    все автоматы, которые принадлежат этому партнёру.
                  </p>
                </div>

                <div style={quickInfoWrap}>
                  <div style={quickInfoCard}>
                    <p style={quickInfoLabel}>Партнёров</p>
                    <p style={quickInfoValue}>{partnersList.length}</p>
                    <p style={quickInfoHint}>в демо-базе</p>
                  </div>

                  <div style={quickInfoCard}>
                    <p style={quickInfoLabel}>Автоматов</p>
                    <p style={quickInfoValue}>{partners.length}</p>
                    <p style={quickInfoHint}>в системе</p>
                  </div>

                  <div style={quickInfoCard}>
                    <p style={quickInfoLabel}>Версий</p>
                    <p style={quickInfoValue}>1</p>
                    <p style={quickInfoHint}>для этого проекта</p>
                  </div>
                </div>
              </div>

              <div style={rightAccentCard}>
                <div style={rightAccentTop}>
                  <div>
                    <p style={rightAccentTitle}>Информация</p>
                    <p style={rightAccentText}>
                      Выбор партнёра происходит на этой странице. Переход дальше
                      выполняется уже из карточки конкретного автомата.
                    </p>
                  </div>

                  <div style={rightAccentDot} />
                </div>

                <div style={rightAccentBottom}>
                  <div style={lineItem}>
                    <span>Категория</span>
                    <strong>Автотовары</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={sectionCard}>
            <div style={controlsGrid}>
              <div style={panelCard}>
                <p style={sectionLabel}>Конфигурация аппарата</p>

                <div style={infoBox}>
                  <p style={infoBoxTitle}>Тип системы</p>
                  <p style={infoBoxValue}>Магазин самообслуживания</p>
                </div>

                <div
                  style={{
                    marginTop: "14px",
                    background: "var(--surface)",
                    border: "1px solid var(--line)",
                    borderRadius: "18px",
                    padding: "18px",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "12px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.04em",
                      color: "var(--text-dim)",
                    }}
                  >
                    Примечание
                  </p>

                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      lineHeight: 1.6,
                      color: "var(--text-muted)",
                    }}
                  >
                    У этого вендинга одна версия, поэтому блок выбора версии не
                    нужен. Сначала выбирается партнёр, затем показываются его аппараты.
                  </p>
                </div>
              </div>

              <div style={panelCard}>
                <p style={sectionLabel}>Поиск партнёра</p>

                <div style={searchBox}>
                  <input
                    style={input}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Начни вводить фамилию или название партнёра"
                  />

                  <p style={helperText}>
                    Нажми на нужного партнёра, и ниже появится список всех его аппаратов.
                  </p>

                  <div style={partnersListStyle}>
                    {filteredPartners.length === 0 ? (
                      <div style={emptyState}>
                        По этому запросу партнёры не найдены.
                      </div>
                    ) : (
                      filteredPartners.map((partner) => {
                        const isSelected = partner.id === selectedPartnerId;

                        return (
                          <div
                            key={partner.id}
                            style={isSelected ? selectedPartnerRow : partnerRow}
                            onClick={() => setSelectedPartnerId(partner.id)}
                          >
                            <div>
                              <p style={partnerName}>{partner.name}</p>
                              <p style={partnerMeta}>
                                {partner.machinesCount} автоматов во владении
                              </p>
                            </div>

                            <div style={selectBadge}>
                              {isSelected ? "Выбран" : "Выбрать"}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={sectionCard}>
            <div style={machinesSection}>
              {selectedPartner ? (
                <>
                  <div style={selectedPartnerCard}>
                    <h2 style={selectedPartnerTitle}>{selectedPartner.name}</h2>
                    <p style={selectedPartnerSub}>
                      Во владении: {selectedPartner.machinesCount} автоматов.
                      Ниже показан список аппаратов этого партнёра.
                    </p>
                  </div>

                  {selectedPartnerMachines.length > 0 ? (
                    <div style={machinesGrid}>
                      {selectedPartnerMachines.map((machine) => (
                        <div key={machine.id} style={machineCard}>
                          <p style={machineLabel}>Автомат</p>
                          <h3 style={machineTitle}>
                            {machine.machineName || `Автомат #${machine.id}`}
                          </h3>

                          <p style={machineText}>
                            <strong>Локация:</strong>{" "}
                            {machine.location || "Не указана"}
                          </p>

                          <p style={machineText}>
                            <strong>ID автомата:</strong> {machine.id}
                          </p>

                          <div style={machineFooter}>
                            <span style={machineStatus}>Активен</span>

                            <Link to={`/partner/${machine.id}`} style={openButton}>
                              Открыть автомат
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={emptyState}>
                      У выбранного партнёра пока нет автоматов.
                    </div>
                  )}
                </>
              ) : (
                <div style={emptyState}>
                  Сначала выбери партнёра в блоке выше, и здесь появятся его автоматы.
                </div>
              )}
            </div>
          </div>

          <div style={bottomNote}>
            Все имена и события вымышлены, любые совпадения с реальными людьми и событиями случайны.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnersPage;
